"use strict";

define('model/message.code',['./base'], function (Base) {
  var MessageCode = Base.extend({
    childModels: {
      'notificationKind': 'NotificationKind'
    }
  });
  return MessageCode;
});

